import varAxios from "../../Comman/axios";
import {AddUpdateRolePermission, DeleteRolePermission,GetRolePermissionList} from '../../Comman/apiEndPoints';

export const Fetch_All_Permissions_Data = "Fetch_All_Permissions_Data";
export const Update_Permissions_List_Success = "Update_Permissions_List_Success";
export const Permissions_Data_Success = "Permissions_Data_Success";
export const Fetch_Permissions_Request = "Fetch_Permissions_Request";

export function getAllPermissionsSettings() {
    return(dispatch) =>{
       return varAxios.get(GetRolePermissionList)
       .then(response => {
          dispatch(
            fetchAllPermissionsData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              permissionsList : response.data.permissionList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllPermissionsData({errorCode, statusCode, permissionsList}) {
  return {
    type : Fetch_All_Permissions_Data,
    errorCode,
    statusCode,
    permissionsList
  }
}
export function addPermissionsData(formData) {
  return (dispatch) => {
      dispatch(fetchPermissionsRequest())
      return varAxios.post(AddUpdateRolePermission, formData,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
             /*  dispatch(
                  updateRegionList(response.data.errorCode,response.data.statusCode,
                    [],response.data.Message)
              ); */
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function updatePermissionsList(errorCode,statusCode,permissionsList,message) {
  return{
    type : Update_Permissions_List_Success,
    errorCode,
    statusCode,
    permissionsList,
    message
  } 
}

export function deletePermissionsData(data) {
  return (dispatch) => {
    dispatch(fetchPermissionsRequest())
      return varAxios.post(DeleteRolePermission,data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              dispatch(
                  PermissionsDataSuccess(response.data.errorCode,response.data.statusCode,
                    response.data.Message)
              );
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function PermissionsDataSuccess(errorCode,statusCode,Message,list) {
  return{
    type : Permissions_Data_Success,
    errorCode,
    statusCode,
    Message,
    list
  } 
}
export function editPermissionsData(formData) {
  return (dispatch) => {
    dispatch(fetchPermissionsRequest())
      return varAxios.post(AddUpdateRolePermission, formData,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              dispatch(
               PermissionsDataSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.permissionList)
              );
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function fetchPermissionsRequest(){
  return{
    type : Fetch_Permissions_Request
  }
}
